const addStyle = () => {
  const ver = new Date().getTime();
  const url = require("./../../global/url");
  const regUpgradeCssLink = `${url.api}/ext-app/css/btutil-regUpgradeModal-v1.min.css`;
  const regUpgradeCss = document.createElement("link");
  regUpgradeCss.setAttribute("id", "popup-css-link");
  regUpgradeCss.setAttribute("rel", "stylesheet");
  regUpgradeCss.setAttribute("href", `${regUpgradeCssLink}?ver=${ver}`);

  if(!document.querySelector("#popup-css-link")) document.querySelector("head")?.append(regUpgradeCss);
}

module.exports = addStyle;